import { OAUTH_TOKENS_SET_LOADING, OAUTH_TOKENS_SET_TOKENS } from '@Actions/oauthTokensPage';
export const defaultState = {
    loading: true,
    tokens: []
};
export function oauthTokensPageReducer(state = defaultState, action) {
    switch (action.type) {
        case OAUTH_TOKENS_SET_LOADING:
            return Object.assign(Object.assign({}, state), { loading: action.payload });
        case OAUTH_TOKENS_SET_TOKENS:
            return Object.assign(Object.assign({}, state), { loading: false, tokens: action.payload });
        default:
            return state;
    }
}
